<template>
  <div class="page-editor__container page-editor__container--small">
    <slot name="heading">
      <base-heading>Intro</base-heading>
    </slot>
    <base-card
      v-if="loading"
      condensed
      style="opacity: 0.5"
    >
      <base-skeleton no-background>
        <div class="skeleton__item mt-2" />
        <hr class="divider">
        <div class="skeleton__item" />
        <hr class="divider">
        <div
          class="skeleton__item"
          style="height: 200px"
        />
      </base-skeleton>
    </base-card>
    <base-card
      v-else
      condensed
      class="intro_borders"
    >
      <div class="m-2">
        <div class="d-flex align-items-center">
          <base-text class="mr-3 customtext">
            To:
          </base-text>
          <email-recipients-editor
            class="w-100"
            :item="item"
            :show-groups="!hideGroups"
            :recipients="recipients"
            @recipients-change="onRecipientsChange"
          />
        </div>
        <hr
          v-if="!hideIntro"
          class="divider"
        >
      </div>
      <editor-intro-text
        v-if="!hideIntro && (intro || !editing)"
        v-model="intro"
        @upload-attachment="onUploadAttachment"
        @clear-attachment="onClearAttachment"
        @attachment-error="onAttachmentError"
      />
    </base-card>
  </div>
</template>

<script>

import EditorIntroText from '@/pages/entries/EditorIntroText';
import EmailRecipientsEditor from '@/components/Widgets/DraftEditor/EmailRecipientsEditor';
import { EventBus } from '@/event-bus';

export default {

  name: 'IntroEditor',
  components: {
    EditorIntroText,
    EmailRecipientsEditor,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
      toGroups: [],
      toCustomers: [],
    },
    value: {
      type: String,
      default: '',
    },
    invitedRecipients: {
      type: Array,
      default: () => [],
    },
    editing: {
      type: Boolean,
      default: false,
    },
    hideIntro: {
      type: Boolean,
      default: false,
    },
    hideGroups: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      intro: '',
      item: {},
      recipients: [],
    };
  },
  watch: {
    value: {
      handler(newval) {
        if (newval) this.$set(this, 'intro', newval);
      },
      immediate: true,
    },
    intro(newval) {
      this.$emit('input', newval);
    },
    recipients(newval) {
      this.$emit('update-recipients', newval);
    },
    preFilledIntro(newval) {
      this.intro = newval;
    },
  },
  mounted() {
    if (this.editing && this.invitedRecipients) {
      this.recipients = this.invitedRecipients.map((item) => ({
        classes: '',
        group: false,
        name: item.customer.last_name ? item.customer.last_name : '',
        object: {
          first_name: item.customer.first_name ? item.customer.first_name : '',
          last_name: item.customer.last_name ? item.customer.last_name : '',
          email: item.customer.email ? item.customer.email : '',
          pk: item.customer.pk,
        },
        text: (item.customer.first_name
          ? `${item.customer.first_name} ${item.customer.last_name}`
          : item.customer.email),
      }));
    }
  },
  methods: {
    onRecipientsChange(items) {
      this.recipients = items;
    },
    onUploadAttachment(url) {
      this.item.attachment = url;
      this.$emit('save');
    },
    onClearAttachment() {
      this.item.attachment = null;
      this.$emit('save');
    },
    onAttachmentError(error) {
      EventBus.$emit('toast-error', error);
    },
  },
};
</script>

<style lang="scss" scoped>
.intro_borders {
    border: 1px solid #D4D4D4;
    border-radius: 5px;
}
</style>
